export default {"src":"/_next/static/media/protection_plan.7b4233bc.svg","height":102,"width":126,"blurWidth":0,"blurHeight":0};